/**
 * Type definitions for Schema.org JSON-LD structured data
 */

// Book format types
export enum BookFormatType {
  AudiobookFormat = 'https://schema.org/AudiobookFormat',
  EBook = 'https://schema.org/EBook',
  GraphicNovel = 'https://schema.org/GraphicNovel',
  Hardcover = 'https://schema.org/Hardcover',
  Paperback = 'https://schema.org/Paperback',
}

// Language types
export enum LanguageType {
  German = 'de-DE',
  French = 'fr-FR',
  English = 'en-GB',
  Italian = 'it-IT',
}

// Availability types
export enum AvailabilityType {
  InStock = 'https://schema.org/InStock',
  OutOfStock = 'https://schema.org/OutOfStock',
  PreOrder = 'https://schema.org/PreOrder',
}

// Event types
export enum EventAttendanceModeType {
  Offline = 'https://schema.org/OfflineEventAttendanceMode',
  Online = 'https://schema.org/OnlineEventAttendanceMode',
  Mixed = 'https://schema.org/MixedEventAttendanceMode',
}

export enum EventStatusType {
  Scheduled = 'https://schema.org/EventScheduled',
  Cancelled = 'https://schema.org/EventCancelled',
  Postponed = 'https://schema.org/EventPostponed',
  Rescheduled = 'https://schema.org/EventRescheduled',
}

// Location types
export enum LocationType {
  Place = 'Place',
  VirtualLocation = 'VirtualLocation',
}

// Event data interface
export interface EventJsonLdData {
  name: string
  startDate: string
  endDate?: string
  location?: {
    type?: LocationType
    name: string
    url?: string
    address?: {
      streetAddress?: string
      addressLocality?: string
      postalCode?: string
      addressRegion?: string
      addressCountry?: string
    }
  }
  image?: string
  description?: string
  offers?: {
    price?: string
    priceCurrency?: string
  }
  isAccessibleForFree?: boolean
  eventAttendanceMode?: EventAttendanceModeType
}

// Book data interface
export interface BookJsonLdData {
  author?: string
  bookFormat?: BookFormatType
  datePublished?: string
  image?: string
  inLanguage?: LanguageType
  isbn?: string
  name: string
  numberOfPages?: number
  offers?: {
    availability?: AvailabilityType
    price?: string
    priceCurrency?: string
  }
}

// BreadcrumbList JSON-LD types
export interface ListItemJsonLd {
  '@type': 'ListItem'
  position: number
  name: string
  item?: string // URL - optional for last item
}

export interface BreadcrumbListJsonLd {
  '@context': 'https://schema.org'
  '@type': 'BreadcrumbList'
  itemListElement: ListItemJsonLd[]
}

export type SchemaObject = Record<string, unknown>
